import React from 'react'
import { IoIosPlay, IoIosPause } from 'react-icons/io'

const ToggleButton = ({ enabled = false, setEnabled }) => {
  const toggleSwitch = () => {
    setEnabled(!enabled)
  }
  return (
    <div
      onClick={toggleSwitch}
      className={` relative flex items-center rounded-full transition-colors duration-300 `}
      style={{
        height: '10px',
        width: '30px',
        background: '#918F91',
      }}
    >
      <div
        className={`absolute top-1/2 transform -translate-y-1/2  bg-white rounded-full transition-transform duration-300 ${
          enabled ? 'translate-x-4' : 'translate-x-0'
        } flex justify-center items-center`}
        style={{ height: '14px', width: '14px', background: enabled ? '#FFFFFF' : '#717171' }}
      >
        {enabled ? (
          <IoIosPlay
            style={{ color: '#717171', height: '10px', width: '10px', marginLeft: '2px' }}
            className=" "
          />
        ) : (
          <IoIosPause style={{ color: '#FFFFFF', height: '10px', width: '10px' }} className=" " />
        )}
      </div>
    </div>
  )
}

export default ToggleButton
